<template>
  <div id="rede-credenciada-empty">
    <div class="info-get-location"
         v-if="permiteGeolocalizacao && geolocalizacao.permissionState === EnumGeolocationPermissionState.PROMPT && !geolocalizacao.lat && !geolocalizacao.lng">
      <p>Faça buscas mais rápidas e precisas utilizando sua localização. Veja os prestadores mais próximos de você.</p>
      <el-button type="primary" @click="getGeolocation">PERMITIR LOCALIZAÇÃO</el-button>
    </div>
    <div class="content-empty">
      <div class="icon-circle">
        <svg-icone :icone="funcionalidade.parametros.dashboard.icone" :width="64" :height="64"
                   :cor="esquemaDeCor.aplicacao.corPrimariaAplicacao" />
      </div>

      <br>
      <h3>
        {{ funcionalidade.parametros.web.labelBoasVindas }}
      </h3>
      <p class="paragraph">
        Use os campos ao lado para encontrar prestadores credenciados em nossa rede.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { EnumGeolocationPermissionState } from '@/constants/EnumsRedeCredenciada'

export default {
  name: 'Func4RedeCredenciadaEmpty',
  props: { getGeolocation: Function },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'esquemaDeCor', 'frameId']),
    ...mapGetters('RedeCredenciada', ['permiteGeolocalizacao', 'geolocalizacao']),
    EnumGeolocationPermissionState () {
      return EnumGeolocationPermissionState
    }
  }
}
</script>

<style scoped lang="less">
#rede-credenciada-empty {
  .info-get-location {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: var(--cor-primaria-aplicacao-transparent);
    padding: 10px 12px;
    margin: 40px 16px;
    border-radius: 10px;
    gap: 20px;

    p {
      color: var(--cor-primaria-aplicacao);
      width: 80%;
    }

    .el-button {
      background-color: var(--cor-primaria-aplicacao);
      height: 32px;
    }
  }
}

.content-empty {
  display: flex;
  flex-direction: column;
  gap: 8px;
  place-items: center;
  color: dimgrey;
  padding: 20px 45px;

  .icon-circle {
    background: var(--cor-primaria-aplicacao-transparent);
    border-radius: 100%;
    padding: 16px;
    line-height: 0;
  }

  .paragraph {
    max-width: 350px;
    text-align: center;
  }
}
</style>
